import { useEffect, useState } from "react";
import { authedFetch } from "./auth";
import { resetUser } from "./posthog";

/** Seeded user offered by the API in AUTH_MODE=dev (local platform dev). */
export interface DevUser {
  key: string;
  id: string;
  email: string;
  displayName: string;
  isOperator: boolean;
  summary: string;
}

/**
 * Seeded dev users, or null when the API is not in dev mode (the endpoint is
 * only mounted with AUTH_MODE=dev, so any non-200 means "not dev").
 */
export function useDevUsers(): DevUser[] | null {
  const [users, setUsers] = useState<DevUser[] | null>(null);
  useEffect(() => {
    let cancelled = false;
    authedFetch("/api/auth/dev/users")
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { users: DevUser[] } | null) => {
        if (!cancelled) setUsers(data?.users ?? null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return users;
}

/** Sign in as a dev user and hard-reload so every cache starts clean. */
export async function devLogin(userKey: string, redirectTo = "/") {
  const res = await authedFetch("/api/auth/dev/login", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ user: userKey }),
  });
  if (!res.ok) throw new Error(`Dev login failed (${res.status})`);
  window.location.href = redirectTo;
}

export async function devLogout() {
  resetUser();
  await authedFetch("/api/auth/dev/logout", { method: "POST" });
  window.location.href = "/login";
}
